export default function CheckArchive(archieveData, archiveDesignation, loggedUserId) {
    let returnValue = false
	if(archieveData.length){
		for (let i = 0; i < archieveData.length; i++) {
			if (archieveData[i].archiveDesignation === archiveDesignation && loggedUserId === archieveData[i].userId) {
				returnValue= true; // Condition met, exit the function
				return returnValue;
			}else{
				returnValue= false;
			}
		}
	}
    return returnValue; // Condition not met
};